module.exports = __webpack_public_path__ + "img/dac-san-chan-nuoi-logo.cb5135ea.jpg";